/**
 * Dev Admin Guard
 * Wraps all routes — requires isDevAdmin: true
 */
import { Navigate, Outlet } from 'react-router-dom'
import { useSnapshot } from 'valtio'
import { Spin } from 'antd'
import { useTranslation } from 'react-i18next'
import { authStore } from '@store/authStore'
import { useCurrentUser } from '@queries/auth'
import { ROUTES } from '@shared/constants'
import { ForbiddenPage } from '@presentation/pages/ForbiddenPage'

export const DevAdminGuard = () => {
  const { t } = useTranslation()
  const { isAuthenticated, isInitialized, user } = useSnapshot(authStore)
  const { isLoading } = useCurrentUser()

  // Loading while initializing or validating
  if (!isInitialized || isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: '#f5f5f5',
          flexDirection: 'column',
          gap: 16,
        }}
      >
        <Spin size="large" />
        <span style={{ color: '#666' }}>{t('common.loading')}</span>
      </div>
    )
  }

  // Not authenticated — redirect to login
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />
  }

  // Authenticated but not a Dev Admin — show 403
  if (!user?.isDevAdmin) {
    return <ForbiddenPage />
  }

  // Authenticated + isDevAdmin — render child routes
  return <Outlet />
}

export default DevAdminGuard
